module.exports = "pegasus/assets/blocks/column-9-tech.png";